export const MARKUP_COLORS = [
  { id: "red", val: "#e5484d" },
  { id: "orange", val: "#f4690f" },
  { id: "amber", val: "#f1a019" },
  { id: "green", val: "#2ea66b" },
  { id: "blue", val: "#2b8cf0" },
  { id: "violet", val: "#8b5cf6" },
];

export const DEFAULT_MODULE_SIZE = {
  arrow: { width: 50, height: 50 },
  circle: { width: 50, height: 50 },
  rectangular: { width: 100, height: 50 },
  photo: { width: 32, height: 44 },
  note: { width: 32, height: 44 },
  checklist: { width: 32, height: 44 },
};

export const SHAPE_TOOLS = ["arrow", "circle", "rectangular", "pen", "measure"];

/** Marker shapes available when placing a deviation observation pin. */
export const DEVIATION_MARKER_TYPES = ["arrow", "circle", "rectangular"];

export const DEFAULT_DEVIATION_MARKER_TYPE = "circle";

export const TOOL_KEYMAP = {
  v: "select",
  h: "pan",
  p: "pen",
  m: "measure",
  a: "arrow",
  o: "circle",
  r: "rectangular",
};

export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

/** Centered sheet placement for a deviation marker at a click point. */
export const deviationMarkerPlacement = (moduleType, point) => {
  const type = DEVIATION_MARKER_TYPES.includes(moduleType)
    ? moduleType
    : DEFAULT_DEVIATION_MARKER_TYPE;
  const defaults = DEFAULT_MODULE_SIZE[type] || DEFAULT_MODULE_SIZE.circle;
  const width = type === "circle" ? 40 : defaults.width;
  const height = type === "circle" ? 40 : defaults.height;
  return {
    type,
    x: point.x - width / 2,
    y: point.y - height / 2,
    width,
    height,
  };
};

/** Content row of the fixed mobile bottom nav (icon + label), excluding safe-area. */
export const DRAWING_MOBILE_BOTTOM_BAR = "3.75rem";

/** Hit-test helper: zoom dock / markup chrome inside the canvas surface. */
export const isViewerChromeTarget = (target) =>
  !!target?.closest?.("[data-viewer-ui]");
